__turbopack_context__.v({
  "actionIcon": "TeamMembersViewCard-module-scss-module__Yv6qrq__actionIcon",
  "editButton": "TeamMembersViewCard-module-scss-module__Yv6qrq__editButton",
  "member": "TeamMembersViewCard-module-scss-module__Yv6qrq__member",
  "memberBorder": "TeamMembersViewCard-module-scss-module__Yv6qrq__memberBorder",
  "root": "TeamMembersViewCard-module-scss-module__Yv6qrq__root",
  "skills": "TeamMembersViewCard-module-scss-module__Yv6qrq__skills",
});
